export const SEOTEXT = 'seotext'
